export const DONE_STATUS_VALIDATION = {
  Handover: {
    label: "Handover Output1",
    name: "handoverOutput1",
  },
};
export const DONE_STATUS_VALIDATION_FIELD_TYPES = {
  subjective: [
    "Handover",
    "Shop Drawing",
    "Client Approval Sd",
    "Shop Drawing Revision",
  ],
};
export const IO_FOR_PRODUCT_EXECUTION_TIMELINE = {
  Handover: {
    isRequiredInDoneStatus: false,
    name: "handover",
    outputItems: ["Handover checklist", "Handover code"],
  },
  "Shop Drawing": {
    isRequiredInDoneStatus: true,
    name: "shopDrawing",
    inputItems: ["Design intent/client drawings", "Material specification"],
    outputItems: ["Shop drawings"],
  },
  "Client Approval Sd": {
    isRequiredInDoneStatus: true,
    name: "clientApprovalSd",
    inputItems: ["Shop drawings"],
    outputItems: ["Client approval"],
  },
  "Shop Drawing Revision": {
    isRequiredInDoneStatus: true,
    name: "shopDrawingRevision",
    inputItems: ["Revised Shop Drawing", "Revised Shop Drawing Comments"],
    outputItems: ["Revised Shop Drawing Comments"],
  },
  "Client Approval Sdr": {
    isRequiredInDoneStatus: true,
    name: "clientApprovalSdr",
    inputItems: ["Final Shop Drawing"],
    outputItems: ["Client approval Email"],
  },
  Proto: {
    isRequiredInDoneStatus: true,
    name: "proto",
    inputItems: ["Approved shop drawing"],
    outputItems: ["QC Report", "Product Location", "Revised Product Drawing"],
  },
  "Client Approval P": {
    isRequiredInDoneStatus: true,
    name: "clientApprovalP",
    inputItems: ["QC report", "Physical product"],
    outputItems: ["Client approval"],
  },
  "Proto Revision": {
    isRequiredInDoneStatus: true,
    name: "protoRevision",
    inputItems: ["Client's comments"],
    outputItems: ["QC Report", "Product Location", "Revised Product Drawing"],
  },
  "Client Approval Pr": {
    isRequiredInDoneStatus: true,
    name: "clientApprovalPr",
    inputItems: ["QC report", "Physical product"],
    outputItems: ["Client approval"],
  },
  Pcd: {
    isRequiredInDoneStatus: true,
    name: "pcd",
    inputItems: [
      "Final QC report",
      "Final Client approved Drawing",
      "Physical Product Location",
    ],
    outputItems: ["PCD Code", "PCD Data Link", "Final Product Location"],
  },
  "Proto Production": {
    isRequiredInDoneStatus: true,
    name: "protoProduction",
    inputItems: [
      "Approved shop drawing",
      "Specific material purchase code and ETA",
    ],
    outputItems: ["QC Report", "Packed ready list", "Final Packing master"],
  },
  Production: {
    isRequiredInDoneStatus: true,
    name: "production",
    inputItems: [
      "Approved client drawings",
      "PCD Code",
      "PCD Data Link",
      "Final Product Location",
      "Physical control samples",
      "Specific material purchase code and ETA",
    ],
    outputItems: ["QC Report", "Packed ready list", "Final Packing master"],
  },
  Dispatch: {
    isRequiredInDoneStatus: true,
    name: "dispatch",
    inputItems: ["Packed ready list", "Final Packing master"],
    outputItems: ["Packing list", "Vehicle details/Ware house details"],
  },
  Buffer: {
    isRequiredInDoneStatus: false,
    name: "buffer",
  },
};
